import AllYesNoCheckbox from "@app/components/all-yes-no-checkbox.tsx";
import FiltersContainer from "@app/components/filters-container.tsx";
import PageTitle from "@app/components/page-title.tsx";
import { defaultClientFilters } from "@app/constants/filters.defaults.tsx";
import useClientData from "@app/data-hooks/use-client-data.ts";
import useLookupListData from "@app/data-hooks/use-lookup-list-data.ts";
import { RouteHelper } from "@app/helpers/route-helper.ts";
import { clientFiltersStore } from "@app/stores/filters.store.ts";
import { clientsTableDefinition } from "@app/table-definitions/clients.table-definition.tsx";
import { Button, TextField } from "@mui/material";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useStore } from "@tanstack/react-store";
import { DataTable, QueryStatusRouter, Select } from "bi-lib";

export const Route = createFileRoute("/_authenticated/_manager/client/")({
    beforeLoad: RouteHelper.ManagerAuthGuard,
    component: Component,
});

function Component() {
    const filters = useStore(clientFiltersStore);

    const navigate = useNavigate();

    const { stateCodeList } = useLookupListData();
    const { clientGrid, updateClientActivation } = useClientData(filters);

    return (
        <>
            <PageTitle>Client Management</PageTitle>
            <FiltersContainer onReset={() => clientFiltersStore.setState(() => defaultClientFilters)}>
                <QueryStatusRouter queryHook={stateCodeList}>
                    <Select
                        label={"State"}
                        sx={{ minWidth: 200 }}
                        value={filters.stateCode}
                        onChange={(e) => clientFiltersStore.setState(() => ({ ...filters, stateCode: e }))}
                        options={stateCodeList.data?.map((x) => ({ label: x.stateName, value: x.stateCodeId }))}
                    />
                </QueryStatusRouter>
                <TextField
                    label={"Search"}
                    value={filters.search ?? ""}
                    onChange={(e) => clientFiltersStore.setState(() => ({ ...filters, search: e.target.value }))}
                    sx={{ minWidth: 150 }}
                />
                <AllYesNoCheckbox
                    value={filters.activeState}
                    onChange={(value) => clientFiltersStore.setState(() => ({ ...filters, activeState: value }))}
                    label={"Active"}
                />
            </FiltersContainer>
            <DataTable
                rowsPerPageOptions={[5000]}
                label={"Clients"}
                actions={
                    <Link to={"/client/create"}>
                        <Button variant={"contained"}>Add New</Button>
                    </Link>
                }
                columns={clientsTableDefinition({
                    onEdit: (id) => void navigate({ to: "/client/$id", params: { id: id.toString() } }),
                    onActivateDeactivate: (id, active) =>
                        updateClientActivation.mutate({
                            clientId: id,
                            isActive: active,
                        }),
                    rowCount: clientGrid.data?.length ?? 0,
                })}
                data={clientGrid.data ?? []}
                queryHook={clientGrid}
            />
        </>
    );
}
